




































































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../lib/util'
import AbpBase from '../../lib/abpbase'
import Hazardouswastestorage from '../../store/entities/hazardouswastestorage'
import appconst from '../../lib/appconst'
@Component
export default class HazardouswastestorageDetail extends AbpBase{

         
    @Prop({type:Boolean,default:false}) value:boolean;

    user:any=[];
     
    hname:string="";
    hid:number=0;
    weight:number=0;

    
    save(){       
        
       // this.user.id
         
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'hazardouswastestorage/updatecurrentweight',
                    data:{id:this.user.id, currentweight:this.user.currentweight}
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }

    visibleChange(value:boolean){
          
        if(!value){
            this.$emit('input',value);
          
       
        }else{
       var pastdata=this.$store.state.hazardouswastestorage.detailHazardouswastestorage;
          var th=this;
         pastdata .then((data) => { 
           console.log(data)
           // alert(data.equipmentmodel.modelname)
            // th.hname=data.smartequipment.serialnumber;
             th.user=data;
             th.hid=data.id;
             th.weight=data.currentweight;
             th.hname=data.smartequipment.serialnumber+" "+data.smartequipment.equipmentmodel.modelname+" "+data.smartequipment.equipmentname;
          
          }).catch((error) => { 
       })

         
        
      // alert(pastdata.smartequipment.serialnumber)
      // this.user=Util.extend(true,{},this.$store.state.hazardouswastestorage.editHazardouswastestorage);
    
         
       
            
        }
    }
    created() {
         

        
    }

    
    
    userRule={
         
  
    }
    


    
}  





